import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'

/**
 * Auto-zoom component to fit all countries in view
 */
export const CountriesAutoZoom = ({ countries, boundsRef }) => {
  const map = useMap()

  useEffect(() => {
    if (!countries || countries.length === 0) return

    // Extract country center coordinates (skip countries without a resolved center)
    const countryPositions = countries
      .filter(country => country.center)
      .map(country => [country.center.lat, country.center.lon])

    if (countryPositions.length === 0) return

    // Small delay to ensure map is fully ready
    const timer = setTimeout(() => {
      if (countryPositions.length === 1) {
        // Single country → center and zoom
        map.setView(countryPositions[0], 6)
        if (boundsRef) {
          boundsRef.current = L.latLngBounds([countryPositions[0]])
        }
      } else if (countryPositions.length > 1) {
        // Multiple countries → fit bounds
        const bounds = L.latLngBounds(countryPositions)
        if (boundsRef) {
          boundsRef.current = bounds
        }
        map.fitBounds(bounds, { padding: [40, 40] })
      }
    }, 100)

    return () => clearTimeout(timer)
  }, [countries, map, boundsRef])

  return null
}
